"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Input = {
    parts: ['field'],
    baseStyle: {
        field: {
            backgroundColor: 'white',
        },
    },
};
exports.default = Input;
